import { pathOr, pathSatisfies } from 'ramda'
import { createSelector } from 'reselect'

import { generateSettingsWebAppConfig } from '@driftt/app-config'

export const currentUser = (state) => state.user

export const currentUserIsBot = (state) => currentUser(state)?.bot ?? false

export const getOrgId = (state) => currentUser(state)?.orgId

export const userProperties = (state) => state.userProperties

export const appConfig = createSelector(
  currentUser,
  userProperties,
  (currentUser, userProperties) =>
    generateSettingsWebAppConfig(currentUser, userProperties)
)

export const hasDesktopApp = (state) =>
  pathSatisfies(
    (hasApp) => !!hasApp && hasApp !== 'false',
    ['settings', 'has_desktop_app']
  )(currentUser(state))

export const currentUserGlobalHandle = (state) =>
  pathOr('', ['profile', 'globalHandle'], currentUser(state))
